export { default as capitalize } from './capitalize';
export {convertToMb} from './convertToMb';
